import Axios from "../../../utils/axios";

export const getTickets = (data) => {
    return (dispatch) => {
        Axios.get("/tickets", dispatch, "GET_TICKETS", data);
    };
};

export const createTicket = (data) => {
    return (dispatch) => {
        return Axios
            .post("/ticket", dispatch, "CREATE_TICKET", data)
            .then((response) => {
                if (response.response.data.status === "success") {
                    const param = {
                        event_id: response.response.data.data.event_id
                    };
                    dispatch(getTickets(param));
                }
                return response;
            });
    };
};

export const updateTicket = (data) => {
    return (dispatch) => {
        return Axios
            .post("/ticket/" + data.id, dispatch, "UPDATE_TICKET", data)
            .then((response) => {
                if (response.response.data.status === "success") {
                    const param = {
                        event_id: response.response.data.data.event_id
                    };
                    dispatch(getTickets(param));
                }
                return response;
            });
    };
};

export const deleteTicket = (data) => {
    return (dispatch) => {
        return Axios
            .delete("/ticket/" + data.id, dispatch, "DELETE_TICKET", data)
            .then((response) => {
                if (response.response.data.status === "success") {
                    const param = {
                        event_id: data.event_id
                    };
                    dispatch(getTickets(param));
                }
                return response;
            });
    };
};